import { logger } from "@hopper-b2b/datadog";

interface ContactContinueDetails {
  stateValue: unknown;
  hasEmail: boolean;
  hasPhoneNumber: boolean;
  hasCountryCode: boolean;
}

interface ContactStateDetails {
  parentState: string;
  childState?: unknown;
}

type ContactTrackingService<TContext, TEvent, TResult> = (
  context: TContext,
  event: TEvent
) => Promise<TResult>;

export const logContactContinueRequested = ({
  stateValue,
  hasEmail,
  hasPhoneNumber,
  hasCountryCode,
}: ContactContinueDetails) => {
  logger().info("Contact checkout continue requested", {
    event: "checkout_contact_continue_requested",
    stateValue: JSON.stringify(stateValue),
    hasEmail,
    hasPhoneNumber,
    hasCountryCode,
    path: window.location.pathname,
  });
};

export const logContactStateObserved = ({
  parentState,
  childState,
}: ContactStateDetails) => {
  logger().info("Contact checkout state observed", {
    event: "checkout_contact_state_observed",
    parentState,
    childState,
    path: window.location.pathname,
  });
};

export const withContactTrackingInstrumentation =
  <TContext, TEvent, TResult>(
    service: ContactTrackingService<TContext, TEvent, TResult>
  ) =>
  async (context: TContext, event: TEvent): Promise<TResult> => {
    const startedAt = Date.now();

    logger().info("Contact checkout tracking started", {
      event: "checkout_contact_tracking_started",
      path: window.location.pathname,
    });

    try {
      const result = await service(context, event);

      logger().info("Contact checkout tracking settled", {
        event: "checkout_contact_tracking_settled",
        durationMs: Date.now() - startedAt,
        path: window.location.pathname,
      });

      return result;
    } catch (error) {
      logger().warn("Contact checkout tracking rejected", {
        event: "checkout_contact_tracking_rejected",
        durationMs: Date.now() - startedAt,
        errorName: error instanceof Error ? error.name : "UnknownError",
        path: window.location.pathname,
      });

      throw error;
    }
  };
